<template>

<div class="main detail-view no-sub-header" style="position: relative; grid-template-columns: 250px 1fr auto;">

	<div class="filters">
		<div class="form-contact">
			<div><b>{{ fullName }}</b></div>
			<label v-if="contact_data.address_1">{{ contact_data.address_1 }}<br></label>
			<label v-if="contact_data.city">{{ contact_data.city + ' ' + contact_data.state + ' ' + contact_data.zip_code }}</label>
			<label v-else>{{ form.transferee_address }}</label>
		</div>
		<div class="divider"></div>
		<div class="button action" @click="saveForm()">Save {{ form.form_version }}</div>
		<div class="button neutral" @click="backToList()">Back To List</div>
		<div class="divider"></div>
		<div :class="['extra-menu-item', id == 'new' ? 'disabled' : '']" @click="printForm()">View as PDF</div>
		<div :class="['extra-menu-item', !can_submit_to_atf ? 'disabled' : '']" @click="showSubmitToATF = can_submit_to_atf">Submit to ATF</div>
		<div :class="['extra-menu-item', !can_submit_to_atf ? 'disabled' : '']" @click="showMarkAsSubmitted = can_submit_to_atf">Mark as Submitted</div>
		<div v-if="id != 'new'" class="extra-menu-item" @click="confirmCancel = true">{{ form.inactive ? 'Reactivate' : 'Cancel' }} this 3310</div>
		<div v-if="!form.pdf_required">
			<div class="divider"></div>
			<div style="margin: 1em 0;">This form was submitted to the ATF{{ form.cleo_forward_date ? ' on ' + $moment(form.cleo_forward_date).format('MM/DD/YYYY') : '' }}.</div>
		</div>
	</div>

	<loading v-if="loading" />

	<div v-else :class="['detail', 'form-detail', { 'show-help': showHelp }]" style="padding: 0 1em 1em 0;">
		<h2 ref="detail_top" class="center">ATF FORM {{ form.form_version }} — REPORT OF MULTIPLE SALE OR OTHER DISPOSITION OF {{ form.form_version == '3310.4' ? 'PISTOLS AND REVOLVERS' : 'CERTAIN RIFLES' }}</h2>
		<div class="two-columns">
			<div>
				<label class="full">1. Date of Report</label>
				<date-input :allowFuture="true" v-model="form.report_date"></date-input>
				<label class="full">2a. Federal Firearms Licensee (FFL) Number</label>
				<input type="text" v-model="form.seller_ffl">
				<label class="full">2b. {{ form.form_version == '3310.4' ? 'Trade/Corporate' : 'Business or Trade' }} Name and Full Address</label>
				<textarea v-model="form.seller_name_address"></textarea>
			</div>
			<div>
				<div class="two-columns">
					<div>
						<label class="full">2c. Are any of the firearm(s) connected to another multiple sale?.</label>
						<binary-toggle v-model="form.connected_to_another_multiple_sale" :labels="'Yes,No'" style="margin: 0.66em 0;" />
					</div>
					<div>
						<label class="full">If Yes, Date</label>
						<date-input v-model="form.connected_to_another_multiple_sale_date" style="margin: 0.66em 0;" ></date-input>
					</div>
				</div>
				<div style="margin: 1em 0;">
					<label class="full">2d. If you sold these firearms at a gun show or other qualifying event, identify the event and provide a complete address of the event.</label>
					<input type="text" v-model="form.event_address">
				</div>
			</div>
		</div>

		<label v-if="form.form_version == '3310.4'">3. Any Combination of Pistols and Revolvers Disposed of to the Same Unlicensed Person at One Time or During Any Five Consecutive Business Days (See Instruction 3.)</label>
		<label v-else>3. Rifles Sold or Otherwise Disposed of to the Same Unlicensed Person at One Time or During Any Five Consecutive Business Days</label>

		<div v-if="firearmsList.length > 0">
			<div v-for="(firearm, index) in firearmsList" :key="'firearm_' + index" class="three-columns" style="position: relative; border-bottom: 1px solid #ccc; padding: 1em 0;">
				<div>
					<label>Manufacturer</label>
					<input type="text" v-model="firearm.manufacturer" />
				</div>
				<div>
					<label>Importer <i>(if any)</i></label>
					<input type="text" v-model="firearm.importer" />
				</div>
				<div>
					<label>Model</label>
					<input type="text" v-model="firearm.model" />
				</div>
				<div>
					<label>Serial Number</label>
					<input type="text" v-model="firearm.serial_number" />
				</div>
				<div>
					<label>Type</label>
					<input type="text" v-model="firearm.gun_type" />
				</div>
				<div>
					<label>Caliber</label>
					<input type="text" v-model="firearm.caliber" />
				</div>
				<div>
					<label class="full">Date Transferred</label>
					<date-input v-model="firearm.disposal_date" />
				</div>
				<div></div>
				<div class="right">
					<div class="button neutral small" style="margin: 1.8em 0 0 0;" @click="removeLine(index)">Remove</div>
				</div>
			</div>
		</div>

		<div class="two-columns" style="margin: 1em 0 0 0; align-items: start;">
			<div>
				<label>Search for a serial number to add to this 3310...</label>
				<div class="input-with-control">
					<input type="search" v-model="searchTerm" placeholder="Serial number..." @search="serialNumberSearch()" v-focus>
					<div class="button action input-go" @click="serialNumberSearch()"><i class="fas fa-search"></i></div>
				</div>
				<div style="margin: 0.5em 0 0 0;">
					<div :class="['button', lastFirearmIsBlank ? 'disabled' : 'action', 'small']" @click="addNewLine()"><i class="fa fa-plus" /></div> 
					<label style="display: inline-block; margin: 0 0 0 0.5em;">Or add an empty set of inputs and enter info manually</label>
				</div>
			</div>
			<div style="margin: 2em 0 0 0;">
				{{ searchMessage }}
			</div>
		</div>

		<div class="two-columns" style="margin: 1em 0; padding: 1em 0 0 0; border-top: 1px solid #ccc;">
			<div>
				<label class="full">4. Transferee's Name <em>(Last, First, Middle)</em></label>
				<input type="text" v-model="form.transferee_name">
				<label class="full">5. Full Residential Address <em>(Number, Street, City, County, State, ZIP Code)</em></label>
				<textarea v-model="form.transferee_address" style="height: 5em;"></textarea>
				<label class="full">6. Sex</label>
				<binary-toggle v-model="form.transferee_sex" :tertiary="true" :labels="'Male,Female,Non-Binary'" :values="'Male,Female,Non-Binary'" style="margin: 0.66em 0;" />
			</div>
			<div>
				<label class="full">7a. Ethnicity</label>
				<binary-toggle v-model="form.transferee_ethnicity" :labels="'Hispanic or Latino,Not Hispanic or Latino'" :values="'hispanic,nonhispanic'" style="margin: 0.66em 0;" />
				<label class="full">7b. Race <em>(Check one or more boxes.) (See instruction 5.)</em></label>
				<div v-if="form.use_new_race_list">
					<checkbox v-model="form.transferee_race.l4" label="American Indian or Alaska Native" style="margin: 0.5em 0;" />
					<checkbox v-model="form.transferee_race.l1" label="Asian" style="margin: 0.5em 0;" />
					<checkbox v-model="form.transferee_race.l2" label="Black or African American" style="margin: 0.5em 0;" />
					<checkbox v-model="form.transferee_race.l6" label="Native Hawaiian or Other Pacific Islander" style="margin: 0.5em 0;" />
					<checkbox v-model="form.transferee_race.l7" label="White" style="margin: 0.5em 0;" />
					<checkbox v-model="form.transferee_race.l5" label="Middle Eastern/North African" style="margin: 0.5em 0;" />
				</div>
				<div v-else>
					<checkbox v-model="form.transferee_race.l4" label="American Indian or Alaska Native" style="margin: 0.5em 0;" />
					<checkbox v-model="form.transferee_race.l1" label="Asian" style="margin: 0.5em 0;" />
					<checkbox v-model="form.transferee_race.l2" label="Black or African American" style="margin: 0.5em 0;" />
					<checkbox v-model="form.transferee_race.l5" label="Native Hawaiian or Other Pacific Islander" style="margin: 0.5em 0;" />
					<checkbox v-model="form.transferee_race.l6" label="White" style="margin: 0.5em 0;" />
				</div>
			</div>
		</div>
		<div class="three-columns">
			<div>
				<label class="full">8. Identification Number</label>
				<input type="text" v-model="form.transferee_id_number">
			</div>
			<div>
				<label class="full">9. Type of Identification <em v-if="form.form_version == '3310.4'">(ID)</em></label>
				<input type="text" v-model="form.transferee_id_type">
			</div>
			<div>
				<label class="full">10. ID State</label>
				<input type="text" v-model="form.transferee_id_state">
			</div>
		</div>
		<div class="one-two-columns" style="grid-column-gap: 0.5em;">
			<div>
				<label class="full">11. Date of Birth</label>
				<date-input v-model="form.transferee_dob"></date-input>
			</div>
			<div>
				<label class="full">12. Place of Birth <em>(City, State, Country)</em></label>
				<input type="text" v-model="form.transferee_pob">
			</div>
		</div>

		<div style="margin: 0.5em 0;">
			<label class="full">13. If the buyer of the firearms listed in item 4 is a person authorized to act on behalf of a corporation, company, association, partnership or other such business entity, you must complete the following, if applicable: <em>(See instruction 6.)</em> 
			<br><strong>Name and Address of Business Entity</strong></label>
			<input type="text" v-model="form.transferee_business_entity">
		</div>

		<div v-if="form.form_version == '3310.4'">
			<label class="full">14a. Identify the official designated by the State or local authorities where you, the FFL, will be forwarding Copy 2.</label>
			<div class="three-columns" style="margin: 0.5em 0;">
				<div>
					<label class="full">Name of Agency</label>
					<input type="text" v-model="form.cleo_name">
				</div>
				<div>
					<label class="full">Full Street Address, City, and State</label>
					<input type="text" v-model="form.cleo_address">
				</div>
				<div>
					<label class="full">14b. Date Copy 2 was forwarded to Agency</label>
					<date-input :allowFuture="true" v-model="form.cleo_forward_date"></date-input>
				</div>
			</div>
			<div class="two-columns">
				<div>
					<label class="full">15. Additional Information Relating to the Transfer of the Firearms <em>(if applicable)</em></label>
					<textarea v-model="form.additional_information" style="height: 5em;"></textarea>
				</div>
				<div>
					<label class="full">16. Name of Employee Filling Out This Form</label>
					<input type="text" v-model="form.employee_name">
					<label class="full">17. Date This Form Was Completed</label>
					<date-input :allowFuture="true" v-model="form.filled_out_date"></date-input>
				</div>
			</div>
		</div>

		<div v-else class="two-columns">
			<div>
				<label class="full">14. Additional Information Relating to the Transfer of the Firearms <em>(if applicable)</em></label>
				<textarea v-model="form.additional_information" style="height: 5em;"></textarea>
			</div>
			<div>
				<label class="full">15. Name of Employee Filling Out This Form</label>
				<input type="text" v-model="form.employee_name">
				<label class="full">16. Date This Form Was Completed</label>
				<date-input :allowFuture="true" v-model="form.filled_out_date"></date-input>
			</div>
		</div>
	</div>

	<div class="form-right-sidebar">

		<div class="sidebar-icon pointer" :class="{ 'icon-selected' : showInstructions }" style="right: 0; top: 18px;" @click="showInstructions = !showInstructions">
			<div class="extra-menu-label">Instructions</div>
			<i class="fas fa-info"></i>
		</div>

		<div v-if="showInstructions" class="form-sidebar-content instructions-content">
			<h2>Instructions</h2>
			<div class="form-content-inner section-a-instructions">
				<ul>
					<li>
						<p>1. Federal Firearms Licensees (FFLs) must use this form to report all transactions in which an unlicensed person acquired any combination of two or more pistols or revolvers totaling two or more at one time or during five consecutive business days. This form is not required when the pistols or revolvers are returned to the same person from whom they are received.</p>
					</li>
					<li>
						<p>2. If this transaction is an additional rearm(s) to a multiple sale(s) previously submitted, check "Yes" and enter the date of the previous Multiple Sale form. (For example a multiple sale for purchases made on a Monday and Friday must be submitted by the close of business Friday. If an additional purchase is made within the five days from the Friday purchase, this purchase is part of the previous multiple sale and must be reported as part of that multiple sale under 2c).</p>
					</li>
					<li>
						<p>3. A separate form is to be submitted for each unlicensed person. If more than six pistols and/or revolvers are involved in a transaction, the information required by Item 3 must be provided for additional Pistols and Revolvers on a separate sheet of paper and shall be attached to the ATF Form 3310.4 covering the transaction.</p>
					</li>
					<li>
						<p>4. Licensees must complete Items 1 through 12, 14, and 16 entirely. Items 13 and 15 must be completed, if applicable.</p>
					</li>
					<li>
						<p>5. Refer to the Race and Ethnicity information provided on the ATF Form 4473 associated with this transaction when lling out the Race and Ethnicity information on this form.</p>
					</li>
					<li>
						<p>6. Business Entities - Information identifying the business entity must be recorded in Item 13. The authorized person receiving the rearms must be identi ed in Items 4 through 12 of this form.</p>
					</li>
					<li>
						<p>7. The report is to be submitted to:</p>
						<p>a. Copy 1 - Email to multiplehandgunsalesforms@atf.gov, fax to 1-877-283-0288 or mail to the ATF National Tracing Center no later than the close of business on the day that the multiple sale or other disposition occurs.</p>
						<p>Mailing address:<br>U.S. Department of Justice<br>Bureau of Alcohol, Tobacco, Firearms and Explosives National Tracing Center<br>244 Needy Road<br>Martinsburg, WV 25405</p>
						<p>b. Copy 2 - To Chief Local Law Enforcement O cial (CLEO). The CLEO is a local or State o cial designated to receive this form. If you do not know your CLEO, contact your local ATF O ce to nd out. Provide Copy 2 to your CLEO.</p>
						<p>Instructions to CLEOs receiving Copy 2 of this form: 18 U.S.C. 923(g)(3)(B) provides in part that you certify in writing every six months that no disclosures have been made and that the multiple sales forms on non-prohibited persons have been destroyed by the CLEO as required by law. The following statement can be used for this purpose: "I hereby certify on behalf of (your speci c agency name) that for the period of six months (give speci c dates) there have been no disclosures of Multiple Sales Forms contrary to the provisions of the Brady Handgun Violence Protection Act, and that all forms and any record of the contents thereof have been destroyed as provided by that law." This statement is to be dated and on your agency letterhead, signed by the proper o cial and forwarded by the CLEO to: U.S. Department of Justice, Bureau of Alcohol, Tobacco, Firearms and Explosives, National Tracing Center, 244 Needy Road, Martinsburg, WV 25405.</p>
						<p>c. Copy 3 - Regulation 478.126a requires the licensee to retain one copy of Form 3310.4 and attach it to the rearms transaction record, ATF Form 4473, executed upon delivery of the pistols or revolvers.</p>
					</li>
					<li>
						<p>8. Additional forms may be obtained online at www.atf.gov or through the ATF Distribution Center by calling (703) 870-7526 or (703) 870-7528.</p>
					</li>
				</ul>
			</div>
		</div>
	</div>


	<div v-if="firearmSearchResults.length > 1" class="modal medium-modal">
		<div class="inner">
			<h2>Multiple Serial Numbers Found</h2>
			<div class="content search-list">
				<div style="display: grid; grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr; grid-column-gap: 1em; margin: 0 0 0.5em 0; font-weight: bold">
					<div>Manufactuer</div>
					<div>Importer</div>
					<div>Model</div>
					<div>Serial Number</div>
					<div>Type</div>
					<div>Calber</div>
					<div>Disposed</div>
				</div>
				<div v-for="(item, index) in firearmSearchResults" class="clickable-list-item" style="display: grid; grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr; grid-column-gap: 1em; padding: 0.25em 0;" @click="assignFirearmToList(item)">
					<div>{{ item.manufacturer }}</div>
					<div>{{ item.importer }}</div>
					<div>{{ item.model }}</div>
					<div>{{ item.serial_number }}</div>
					<div>{{ item.gun_type }}</div>
					<div>{{ item.caliber }}</div>
					<div>{{ item.disposal_date }}</div>
				</div>
			</div>
			<div class="controls">
				<div class="button cancel" @click="firearmSearchResults = []">Cancel</div>
			</div>
		</div>
	</div>

	<div v-if="showSavingForm" class="modal">
		<div class="inner" style="width: 20em; height: 10em;">
			<h2>{{ savingForm ? 'Saving' : 'Saved' }}</h2>
			<div class="content">
				<div style="font-size: 2em; text-align: center;">
					<i v-if="savingForm" class="fas fa-spinner fa-spin"></i>
					<i v-else class="fas fa-check"></i>
				</div>
			</div>
		</div>
	</div>

	<div v-if="showSubmitToATF" class="modal modal">
		<div class="inner">
			<h2>Submit {{ form.form_version }} to ATF</h2>
			<div class="content">
				<p>We'll send a PDF copy of this form to the email address(es) below...</p>
				<div v-if="form.form_version == 3310.12">
					<checkbox v-model="cleoInfo.use_default_long_guns" label="multiplelonggunsalesforms@atf.gov" class="v-spaced"/>
					<input type="text" v-model="cleoInfo.email_long_guns_1" :placeholder="(cleoInfo.use_default_long_guns ? 'Additional' : 'Alternate') + ' email address'">
					<input type="text" v-model="cleoInfo.email_long_guns_2" :placeholder="(cleoInfo.use_default_long_guns ? 'Additional' : 'Alternate') + ' email address'">
					<input type="text" v-model="cleoInfo.email_long_guns_3" :placeholder="(cleoInfo.use_default_long_guns ? 'Additional' : 'Alternate') + ' email address'">
				</div>
				<div v-else>
					<checkbox v-model="cleoInfo.use_default_handguns" label="multiplehandgunsalesforms@atf.gov" class="v-spaced"/>
					<input type="text" v-model="cleoInfo.email_handguns_1" :placeholder="(cleoInfo.use_default_handguns ? 'Additional' : 'Alternate') + ' email address'">
					<input type="text" v-model="cleoInfo.email_handguns_2" :placeholder="(cleoInfo.use_default_handguns ? 'Additional' : 'Alternate') + ' email address'">
					<input type="text" v-model="cleoInfo.email_handguns_3" :placeholder="(cleoInfo.use_default_handguns ? 'Additional' : 'Alternate') + ' email address'">
				</div>
				<p v-if="getClient.email_address">You'll also receive a copy at {{ getClient.email_address }}</p>
				<div v-if="modalMessage" class="message-overlay">
					<p v-html="modalMessage"></p>
					<p v-if="saving"><i class="fa fa-spinner fa-spin" /></p>
					<p v-if="modalSuccess"><i class="fa fa-check" /></p>
				</div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="cancelSubmitToATF()">Cancel</div>
				<div :class="['button', saving ? 'disabled' : 'action', 'spaced']" @click="doSubmitToATF('submit')">Submit Form</div>
			</div>
		</div>
	</div>

	<div v-if="showMarkAsSubmitted" class="modal modal">
		<div class="inner">
			<h2>Mark {{ form.form_version }} as Submitted</h2>
			<div class="content">
				<p style="margin: 2em 0;">If you've already submitted this form for <b>{{ fullName }}</b>, you can mark it as submitted so it will show the checkmark in your list.</p>
				<div v-if="modalMessage" class="message-overlay">
					<p>{{ modalMessage }}</p>
					<p v-if="saving"><i class="fa fa-spinner fa-spin" /></p>
					<p v-if="modalSuccess"><i class="fa fa-check" /></p>
				</div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="cancelSubmitToATF()">Cancel</div>
				<div :class="['button', saving ? 'disabled' : 'action', 'spaced']" @click="doSubmitToATF('mark')">Mark as Submitted</div>
			</div>
		</div>
	</div>

	<div v-if="confirmCancel" class="modal">
		<div class="inner">
            <h2>Confirm {{ this.form.inactive ? 'Re-activate' : 'Cancel' }}</h2>
            <div class="content">
                <p><strong>You are about to {{ this.form.inactive ? 're-activate this form' : 'mark this form as canceled' }}.</strong></p>
                <p v-if="!this.form.inactive">Canceled forms aren't normally shown in your 3310 list, but you can filter for them as needed.</p>
                <p>Are you sure you want to proceed?</p>
            </div>
            <div class="controls">
                <div class="button cancel spaced" @click="confirmCancel = false">No</div>
                <div class="primary button spaced" @click="cancelForm()">Yes</div>
            </div>
		</div>
	</div>

	<help-popup :helpLink="{329:'3310 Forms'}" :tours="false"></help-popup>

</div>

</template>

<script>
const FIREARM = { manufacturer: null, model: null, serial_number: null, gun_type: null, caliber: null, disposal_date: null, importer: null }
import { mapGetters, mapActions } from 'vuex'
import DateInput from '@/components/DateInput'
import BinaryToggle from '@/components/BinaryToggle.vue'
import Checkbox from '@/components/Checkbox.vue'
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'form3310-detail',
	props: ['id'],
	components: {
		'date-input': DateInput,
		'binary-toggle': BinaryToggle,
		'checkbox': Checkbox,
		'help-popup': HelpPopup
	},
	data() {
		return {
			loading: false,
			client_id: '',
			message: '',
			searchMessage: '',
			searchTerm: '',
			contact_data: {},
			showHelp: false,
			firearmSearchResults: [],
			firearmsList: [],
			form: {
				transferee_race: {
					l4: false, // American Indian or Alaskan Native
					l2: false, // African American or Black
					l6: false, // White
					l1: false, // Asian
					l5: false // Native Hawaiian or Other Pacific Islander
				}
			},
			can_submit_to_atf: false,
			showSavingForm: false,
			savingForm: false,
			cleoInfo: {},
			showSubmitToATF: false,
			showMarkAsSubmitted: false,
			submittingToATF: false,
			saving: false,
			modalMessage: '',
			modalSuccess: false,
			showInstructions: false,
			confirmCancel: false
		}
	},
	created() {
		this.getCLEOInfo()
		if (this.id != 'new') {
			this.fetchForm()
		} else {
			this.form.form_version = this.$route.query.form_version
			this.form.pdf_required = 1
			this.assignClientInfo()
			if (this.$route.query.contact_id) {
				this.form.contact_id = this.$route.query.contact_id
				if (this.$route.query.ffl_multiple_purchase_id) {
					this.form.ffl_multiple_purchase_id = this.$route.query.ffl_multiple_purchase_id
				}
				this.getContact()
			}
		}
	},
	mounted() {
		this.form.report_date = this.$moment().format('YYYY-MM-DD')
		this.form.filled_out_date = this.$moment().format('YYYY-MM-DD')
	},
	computed: {
		fullName() {
			if (!this.form.transferee_name && !this.contact_data) return ''
			if (this.id == 'new') {
				return this.form.transferee_name
			} else {
				return this.form.transferee_name || ((this.contact_data.company_name) ? this.contact_data.company_name : this.contact_data.first_name + " " + this.contact_data.last_name)
			}
		},
		...mapGetters([
			'getClient',
			'getApiEndpoint'
		]),
		lastFirearmIsBlank() {
			let isBlank = true
			if (this.firearmsList.length > 0) {
				for (const [key, value] of Object.entries(this.firearmsList[this.firearmsList.length - 1])) {
					if (value) {
						isBlank = false
					}
				}
			} else {
				isBlank = false
			}
			return isBlank
		}
	},
	watch: {
		id (newVal) {
			if (newVal != 'new') {
				this.fetchForm()
			}
		}
	},
	methods: {
		...mapActions('logbooks', [
			'updateLoadingModule',
		]),
		fetchForm() {
			if (this.loading) { return }
			this.loading = true
			this.apiCall({ destination: 'get_item_ffl_log_book_form', data: { ffl_log_book_form_id: this.id }}).then(obj => {
				this.loading = false
				this.client_id = obj.client_id
				if (obj.contact_data) {
					this.contact_data = obj.contact_data
				}
				this.form = obj.log_book_form.form_data

				// convert firearms_list from object to array!
				this.firearmsList = []
				for (const [key, firearm] of Object.entries(this.form.firearms_list)) {
					this.firearmsList.push(firearm)
				}

				this.form.ffl_log_book_form_id = obj.log_book_form.ffl_log_book_form_id
				this.form.contact_id = obj.log_book_form.contact_id
				this.form.pdf_required = obj.log_book_form.pdf_required
				this.can_submit_to_atf = obj.log_book_form.can_submit_to_atf
				this.form.inactive = obj.log_book_form.inactive
				if (!this.form.form_version) {
					this.form.form_version = '3310.4' // default for opening existing forms
				}
				if (!this.cleoInfo.cleo_name && this.form.cleo_name) {
					this.cleoInfo.cleo_name = this.form.cleo_name
				}
				if (!this.cleoInfo.cleo_address && this.form.cleo_address) {
					this.cleoInfo.cleo_address = this.form.cleo_address
				}
				// slight delay while dom updates
				setTimeout(() => {
					this.$refs['detail_top'].scrollIntoView( { behavior: "smooth", block: "start", inline: "nearest" } )
				}, 100)
			}).catch(err => {
				this.loading = false
				console.log(err)
			})
		},
		serialNumberSearch() {
			if (this.loading || !this.searchTerm) { return }
			this.searchMessage = ''
			let excludeFromSearch = []
			for (let i = 0; i < this.firearmsList.length; i++) {
				excludeFromSearch.push(this.firearmsList[i].serial_number)
			}
			// per conversation with Andrew, dealers CAN look up non-disposed serial numbers
			this.apiCall({ destination: 'serial_number_lookup', data: { disposed: 0, search_term: this.searchTerm, exclude: excludeFromSearch }}).then(obj => {
				if (obj.status == 'error' || obj.firearms_list.length == 0) {
					this.searchMessage = 'Serial number not found.'
				} else if (obj.firearms_list.length > 1) {
					this.firearmSearchResults = obj.firearms_list
				} else if (obj.firearms_list.length == 1) {
					this.assignFirearmToList(obj.firearms_list[0])
					this.searchTerm = ''
				}
			}).catch(err => {
				console.log(err)
			})
		},
		assignFirearmToList(firearm) {
			this.firearmsList.push({ 
				ffl_log_book_entry_id: firearm.ffl_log_book_entry_id,
				caliber: firearm.caliber,
				gun_type: firearm.gun_type,
				manufacturer: firearm.manufacturer,
				importer: firearm.importer,
				model: firearm.model,
				serial_number: firearm.serial_number,
				disposal_date: firearm.disposal_date
			})
			this.firearmSearchResults = []
			this.searchTerm = ''
		},
		addNewLine() {
			// is the last line already blank?
			if (this.lastFirearmIsBlank) { return }
			this.firearmsList.push({ 
				ffl_log_book_entry_id: '',
				caliber: '',
				gun_type: '',
				manufacturer: '',
				importer: '',
				model: '',
				serial_number: '',
				disposal_date: ''
			})
		},
		removeLine(index) {
			this.firearmsList.splice(index, 1)
		},
		getContact() {
			this.apiCall({ destination: 'get_item_contact', data: { contact_id: this.form.contact_id }}).then(obj => {
				this.loading = false
				this.assignContact(obj.contact)
			}).catch(err => {
				this.loading = false
				console.log(err);
			})
		},
		assignContact(contact) {
			this.form.contact_id = contact.contact_id
			if (contact.last_name) {
				this.form.transferee_name = contact.last_name
				this.form.transferee_name += ', ' + contact.first_name
				this.form.transferee_name += contact.middle_name ? ' ' + contact.middle_name : ''
			} else {
				this.form.transferee_name = contact.company_name
			}
			this.form.transferee_address = contact.address_1 + "\n"
			this.form.transferee_address += (contact.address_2) ? contact.address_2 + "\n" : ""
			this.form.transferee_address += contact.city + ", " + contact.state + " " + contact.zip_code
			this.form.transferee_dob = contact.birthdate
			this.contact_data = contact
			this.getItemMultiplePurchaseContact()
		},
		assignClientInfo() {
			this.form.seller_ffl = this.getClient.ffl_number 
			this.form.seller_name_address = this.getClient.company_name + "\n"
			this.form.seller_name_address += this.getClient.address_1 + "\n"
			if (this.getClient.address_1) {
				this.form.seller_name_address += this.getClient.address_2 + "\n"
			}
			this.form.seller_name_address += this.getClient.city + ", " + this.getClient.state + " " + this.getClient.zip_code
			this.form.cleo_forward_date = this.$moment().format('YYYY-MM-DD')
		},
		getItemMultiplePurchaseContact() {
			this.loading = true
			let data = {
				contact_id: this.form.contact_id,
				ffl_multiple_purchase_id: this.form.ffl_multiple_purchase_id,
				form_version: this.form.form_version
			}
			this.apiCall({ destination: 'get_item_multiple_purchase_contact', data }).then(obj => {

				this.firearmsList = obj.multiple_purchase_firearms

				if (obj.multiple_purchase_4473_data.version) {
					if (obj.multiple_purchase_4473_data.version === 1) {
						this.form.transferee_name = obj.multiple_purchase_4473_data.customerValues.LAST_NAME.replace(' IO', '')
						this.form.transferee_name += ', ' + obj.multiple_purchase_4473_data.customerValues.FIRST_NAME.replace(' IO', '')
						this.form.transferee_name += (obj.multiple_purchase_4473_data.customerValues.MIDDLE_NAME == 'MNM' || obj.multiple_purchase_4473_data.customerValues.MIDDLE_NAME == 'NMN') ? '' : ' ' + obj.multiple_purchase_4473_data.customerValues.MIDDLE_NAME
						this.form.transferee_sex = obj.multiple_purchase_4473_data.customerValues.GENDER_CODE
						this.form.transferee_id_number = obj.multiple_purchase_4473_data.section_b.buyer_identification_number
						this.form.transferee_id_type = obj.multiple_purchase_4473_data.section_b.buyer_identification_type_code
						this.form.transferee_id_state = obj.multiple_purchase_4473_data.section_b.buyer_identification_issuing_authority_and_type
						this.form.transferee_dob = obj.multiple_purchase_4473_data.customerValues.DOB
						this.form.transferee_pob = obj.multiple_purchase_4473_data.birth_city
						this.form.transferee_pob += ', ' + obj.multiple_purchase_4473_data.customerValues.POB_CODE
						if (obj.multiple_purchase_4473_data.customerValues.POB_CODE in this.STATES_LIST) {
							// Must be a US state, so append US
							this.form.transferee_pob += ', US'
						}
						this.form.transferee_race = obj.multiple_purchase_4473_data.customerRace
					} else {
						this.form.transferee_name = obj.multiple_purchase_4473_data.last_name
						this.form.transferee_name += ', ' + obj.multiple_purchase_4473_data.first_name
						this.form.transferee_name += (obj.multiple_purchase_4473_data.middle_name == 'MNM' || obj.multiple_purchase_4473_data.middle_name == 'NMN') ? '' : ' ' + obj.multiple_purchase_4473_data.middle_name
						// 4473 uses M, F, U but 3310 uses Male, Female, Non-binary
						switch (obj.multiple_purchase_4473_data.gender_code) {
							case 'M':
								this.form.transferee_sex = 'Male'
								break
							case 'F':
								this.form.transferee_sex = 'Female'
								break
							case 'U':
								this.form.transferee_sex = 'Non-binary'
								break
						}
						// update the address with 4473 data, including county
						this.form.transferee_address = obj.multiple_purchase_4473_data.address_1 + "\n"
						this.form.transferee_address += obj.multiple_purchase_4473_data.city + " " + obj.multiple_purchase_4473_data.county + " " + obj.multiple_purchase_4473_data.state + " " + obj.multiple_purchase_4473_data.zip_code
						this.form.transferee_id_number = obj.multiple_purchase_4473_data.buyer_identification_number
						this.form.transferee_id_type = obj.multiple_purchase_4473_data.buyer_identification_type_code
						this.form.transferee_id_state = obj.multiple_purchase_4473_data.buyer_identification_issuing_authority_and_type
						this.form.transferee_dob = obj.multiple_purchase_4473_data.birthdate
						if (obj.multiple_purchase_4473_data.foreign_country) {
							this.form.transferee_pob = obj.multiple_purchase_4473_data.foreign_country
						} else if (obj.multiple_purchase_4473_data.birth_city) {
							this.form.transferee_pob = obj.multiple_purchase_4473_data.birth_city
							this.form.transferee_pob += ', ' + obj.multiple_purchase_4473_data.pob_code
							if (obj.multiple_purchase_4473_data.pob_code in this.STATES_LIST) {
								// Must be a US state, so append US
								this.form.transferee_pob += ', US'
							}
						} else {
							this.form.transferee_pob = ''
						}
						this.form.transferee_race = obj.multiple_purchase_4473_data.customer_race
					}
					this.form.transferee_ethnicity = obj.multiple_purchase_4473_data.ethnicity
				}
				this.loading = false

				// automatically save a generated form!
				this.saveForm()

				// slight delay while dom updates
				setTimeout(() => {
					this.$refs['detail_top'].scrollIntoView( { behavior: "smooth", block: "start", inline: "nearest" } )
				}, 100)
			}).catch(err => {
				this.loading = false
				console.log(err);
			})
		},
		saveForm() {
			if (this.savingForm) { return }
			this.savingForm = true
			this.showSavingForm = true;
			this.form.firearms_list = this.firearmsList
			var data = {
				ffl_log_book_form_id: this.form.ffl_log_book_form_id,
				form_data: this.form
			}
			this.apiCall({ destination: 'save_form_3310', data: data }).then(obj => {
				this.savingForm = false
				if (obj.status == 'success') {
					this.message = "Your form has been saved."
					setTimeout(() => {
						this.message = ''
						this.showSavingForm = false;
					}, 2000)
					this.form.pdf_required = 1
					if (this.id == 'new') {
						this.$router.push("/logbooks/3310/" + obj.ffl_log_book_form_id)
					} else {
						this.fetchForm()
					}
				} else {
					this.message = obj.message
					this.showSavingForm = false;
				}
			}).catch(err => {
				console.log(err)
			})
		},
        cancelForm() {
			console.log(this.ffl_log_book_form_id, this.form.inactive)
			this.apiCall({ destination: 'save_3310_inactive', data: { ffl_log_book_form_id: this.id, current_inactive: this.form.inactive } }).then((obj) => {
                this.backToList()
			}).catch((err) => {
				console.log(err)
			})
        },
		printForm() {
			if (!this.form.ffl_log_book_form_id) { return }
			let url = this.getPDFAPIEndpoint + '?action=form_3310_pdf&source=logbooks&fd_token=' + getCookie('dashboard_token') + '&form_id=' + this.$randomString(6) + this.form.ffl_log_book_form_id + this.$randomString(6) + this.id + this.$randomString(6) + this.client_id + this.$randomString(3)
			window.open(url, '_blank')
		},
		getCLEOInfo() {
            this.apiCall({ destination: 'get_item_preference', data: { preference_code: 'CLEO_AGENCY_INFO' } }).then(obj => {
				if (obj.CLEO_AGENCY_INFO && obj.CLEO_AGENCY_INFO != '') {
					this.cleoInfo = JSON.parse(obj.CLEO_AGENCY_INFO)
				} else {
					this.cleoInfo.use_default_handguns = true
					this.cleoInfo.use_default_long_guns = true
				}
				if (!this.form.cleo_name && this.cleoInfo.cleo_name) {
					this.form.cleo_name = this.cleoInfo.cleo_name
				}
				if (!this.form.cleo_address && this.cleoInfo.cleo_address) {
					this.form.cleo_address = this.cleoInfo.cleo_address
				}
			}).catch(err => {
                console.log(err);
            })
		},
		submitToATF() {
			if (!this.can_submit_to_atf) { return }
			this.showSubmitToATF = true
		},
		doSubmitToATF(action) {
			if (!this.can_submit_to_atf || this.saving) { return }
			this.modalMessage = action == 'mark' ? 'Marking this form as submitted...' : 'Submitting this form to ATF...'
			this.saving = true
			if (action == 'submit') {
				// first save CLEO info
				this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'CLEO_AGENCY_INFO', value: JSON.stringify(this.cleoInfo) } }).then(obj => {
					// then call action=form_3310_pdf with a flag to submit to atf
					this.apiCall({ destination: this.getPDFAPIEndpoint + '?action=form_3310_pdf', data: { client_id: this.client_id, form_id: this.form.ffl_log_book_form_id, submit_to_atf: 1 }}).then(obj => {
						this.saving = false
						this.modalMessage = obj.message
						if (obj.status == 'success') {
							if (obj.to_addresses) {
								this.modalMessage += '<br>'
								for (let i = 0; i < obj.to_addresses.length; i++) {
									this.modalMessage += obj.to_addresses[i] + '<br>'
								}
							}
							this.fetchForm()
							setTimeout(() => {
								this.cancelSubmitToATF()
							}, 3000)
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(err => {
					console.log(err);
				})
			} else {
				// simply mark the form as submitted
				this.apiCall({ destination: 'mark_item_ffl_log_book_as_submitted', data: { ffl_log_book_form_id: this.id } }).then(obj => {
					this.saving = false
					this.modalMessage = obj.message
					if (obj.status == 'success') {
						this.fetchForm()
						setTimeout(() => {
							this.cancelSubmitToATF()
						}, 2000)
					}
				}).catch(err => {
					console.log(err)
				})
			}
		},
		cancelSubmitToATF() {
			this.saving = false
			this.modalMessage = ''
			this.showSubmitToATF = false 
			this.showMarkAsSubmitted = false
		},
		backToList() {
			this.$router.push('/logbooks/3310')
		}
	}
}
</script>


<style lang="scss" scoped>
.form-right-sidebar {
	margin-left: 1em;
	.form-sidebar-content {
		min-width: 250px;
		margin-top: 2.5em;
		background-color: #ededed;
		border: 1px solid #ccc;
		box-shadow: -2px -2px 5px #e2e2e2;
	}
	.form-sidebar-content {
		.form-content-inner {
			max-width: 250px;
			padding: 0.5em;
			overflow: scroll;
			max-height: 65vh;
			ul {
				list-style: none;
				li {
					margin-bottom: 1em;
				}
			}
		}
	}
}
</style>
